import React, { useEffect, useRef, useState } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { contactUsAction, getContactPageNameListAsync } from "../redux";
import ContactUsTable from "./contact_us_detail/contactUsTable";
import {
  Card,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import Select from "react-select";
import { useParams, useHistory } from "react-router-dom";
import { useIsAccessAllow } from "../../users/redux";
import "../../cold_leads/pages/coldLeads.scss";

export function ContactUs() {
  const dispatch = useDispatch();
  const history = useHistory();
  const searchContactRef = useRef();
  const { pageType: currentPageType } = useParams();

  let type = currentPageType ? currentPageType : "all";

  const {
    searchText,
    pageNameList,
    audioType,
    leadType,
    callOutcomeFilter,
  } = useSelector((state) => state.contactUs, shallowEqual);
  // eslint-disable-next-line
  const [pageType, setPageType] = useState(currentPageType);

  const pageTypeOptions = (pageNameList || []).map((option) => {
    const value =
      typeof option === "object" && option !== null ? option.value : option;
    const label =
      typeof option === "object" && option !== null ? option.label : option;

    return {
      value,
      label: value === "all" || label === "all" ? "All Pages" : label,
    };
  });

  const defaultPageType = pageTypeOptions.find((opt) => opt.value === type) || {
    value: type,
    label: type === "all" ? "All Pages" : type,
  };
  useEffect(() => {
    dispatch(getContactPageNameListAsync());
    // eslint-disable-next-line
  }, []);

  // Removed duplicate API call - handled by ContactUsTable component

  const onSearchTextChange = (e) => {
    dispatch(contactUsAction.searchTextChange(e.target.value));
  };

  const changePageType = (e) => {
    setPageType(e.value);
    if (e.value === "all") {
      history.push("/contact-us");
    } else {
      history.push("/contact-us/" + e.value);
    }
    dispatch(contactUsAction.searchTextChange(""));
  };

  const audioTypeOptions = [
    { value: "all", label: "All Data" },
    { value: "with_audio", label: "With Audio" },
    { value: "with_out_audio", label: "Without Audio" },
  ];

  const defaultAudioType =
    audioTypeOptions.find((opt) => opt.value === audioType) ||
    audioTypeOptions[0];

  const changeAudioType = (e) => {
    dispatch(contactUsAction.setAudioType(e.value));
  };

  const leadTypeOptions = [
    { value: "all", label: "All Leads" },
    { value: "genuine", label: "Genuine" },
    { value: "promotional", label: "Promotional" },
    { value: "spam", label: "Spam" },
  ];

  const defaultLeadType =
    leadTypeOptions.find((opt) => opt.value === leadType) || leadTypeOptions[0];

  const changeLeadType = (e) => {
    dispatch(contactUsAction.setLeadType(e.value));
  };

  const callOutcomeOptions = [
    { value: "all", label: "All Outcomes" },
    { value: "Call Concluded", label: "Call Concluded" },
    { value: "Not Concluded", label: "Not Concluded" },
    { value: "Not Interested", label: "Not Interested" },
    { value: "Interested in future", label: "Interested in future" },
  ];

  const defaultCallOutcome =
    callOutcomeOptions.find((opt) => opt.value === callOutcomeFilter) ||
    callOutcomeOptions[0];

  const changeCallOutcomeFilter = (e) => {
    dispatch(contactUsAction.setCallOutcomeFilter(e.value));
  };

  const isSearchAllow = useIsAccessAllow("contact_us.list");

  return (
    <>
      <Card
        style={{
          background: "#ffffff",
          borderRadius: 16,
          boxShadow: "0 15px 40px rgba(15, 23, 42, 0.08)",
          border: "1px solid #e5e7eb",
          overflow: "hidden",
        }}
      >
        <CardHeader
          title={
            <span style={{ fontSize: "20px", fontWeight: 600 }}>
              Contact Us
            </span>
          }
          className="cold-leads-card-header"
        >
          <CardHeaderToolbar>
            <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center margin-left-auto">
              <form
                className="subheader_filter"
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="form-row">
                  <div
                    className="form-group mr-3 mb-1 p-0"
                    style={{ width: "200px" }}
                  >
                    <Select
                      classNamePrefix="react-select"
                      placeholder="Select page type"
                      className="custom-react-select"
                      options={pageTypeOptions}
                      onChange={changePageType}
                      value={defaultPageType}
                    />
                  </div>
                  <div
                    className="form-group mr-3 mb-1 p-0"
                    style={{ width: "200px" }}
                  >
                    <Select
                      classNamePrefix="react-select"
                      placeholder="Select audio type"
                      className="custom-react-select"
                      options={audioTypeOptions}
                      onChange={changeAudioType}
                      defaultValue={defaultAudioType}
                      value={defaultAudioType}
                    />
                  </div>
                  <div
                    className="form-group mr-3 mb-1 p-0"
                    style={{ width: "200px" }}
                  >
                    <Select
                      classNamePrefix="react-select"
                      placeholder="Select lead type"
                      className="custom-react-select"
                      options={leadTypeOptions}
                      onChange={changeLeadType}
                      defaultValue={defaultLeadType}
                      value={defaultLeadType}
                    />
                  </div>
                  <div
                    className="form-group mr-3 mb-1 p-0"
                    style={{ width: "200px" }}
                  >
                    <Select
                      classNamePrefix="react-select"
                      placeholder="All Outcomes"
                      className="custom-react-select"
                      options={callOutcomeOptions}
                      onChange={changeCallOutcomeFilter}
                      value={defaultCallOutcome}
                    />
                  </div>
                  {isSearchAllow && (
                    <div className="form-group mb-1">
                      <div className="custom-search-input">
                        <input
                          name="Search"
                          placeholder="Search..."
                          type="text"
                          value={searchText}
                          autoComplete="off"
                          onChange={onSearchTextChange}
                          ref={searchContactRef}
                        />
                        <div className="search-icon-wrapper">
                          <span className="svg-icon">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/custom/search-outline.svg",
                              )}
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </CardHeaderToolbar>
        </CardHeader>
        <ContactUsTable />
      </Card>
    </>
  );
}
